var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKibana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f04e98",
    d: "M112 0H12v48c17.3 0 33.54 4.453 47.73 12.188Zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#343741",
    d: "M12 48v67.152l47.73-54.96A99.422 99.422 0 0 0 12 48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00bfb3",
    d: "m70.04 66.621-48.974 56.406L16.738 128h93.258c-5.121-25.21-19.758-46.945-39.957-61.379"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKibana);
export default __webpack_public_path__ + "static/media/kibana.daa4c4e93163c04276d213e686ead484.svg";
export { ForwardRef as ReactComponent };